exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.field-focus-border[data-v-83acec68] .van-field__body{border:.025rem solid #ffc72b !important\n}\n.field-border[data-v-83acec68] .van-field__body{border:.025rem solid #dcdfe6\n}\n", "", {"version":3,"sources":["D:/TsWeb/h5aliex/src/view/InscriptionArea/compontents/cuField.vue"],"names":[],"mappings":";AAAA,sDAA4C,uCAAuC;CAAC;AAAA,gDAAsC,4BAA4B;CAAC","file":"cuField.vue","sourcesContent":[".field-focus-border /deep/ .van-field__body{border:.025rem solid #ffc72b !important}.field-border /deep/ .van-field__body{border:.025rem solid #dcdfe6}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?sourceMap!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-83acec68","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/view/InscriptionArea/compontents/cuField.vue
// module id = 7eRT
// module chunks = 0